/* global document */
'use strict';

export function getBaseUrl(script) {
    if (script && script.src) {
        const location = getLocation(script.src);

        let baseUrl = `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''}`;

        return baseUrl.replace('fe.videotron.com', 'fe.videotron.net');
    }
    return null;
}

export function getLocation(url) {
    const link = document.createElement('a');

    link.href = url;

    if (link.host === '') {
        // transform IE relative url to absolute url
        link.href = link.href;
    }
    return link;
}

export function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
}

/**
 * Execute functions in parallel.
 * Waits for all functions to be completed.
 * See https://github.com/caolan/async
 */
export function parallel(functions, cb) {
    let count = functions.length;
    let error;

    functions.forEach((fn) => {
        fn.call(fn, callback);
    });

    function callback(err) {
        count--;

        if (err) {
            error = err;
        }

        if (count === 0) {
            cb(error);
        }
    }
}

/**
 * querySelector/querySelectorAll must be escaped for dots.
 *
 * <div id="my.id"></div>
 * document.querySelector('#my\\.id')
 */
export function escapeSelector(selector) {
    return selector.replace(/\./g, '\\.');
}

// Detect ie version using conditional comments
// see https://gist.github.com/padolsey/527683
export const ieVersion = (function () {
    let v = 6;
    const div = document.createElement('div');
    const all = div.getElementsByTagName('i');

    do {
        div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->'; // eslint-disable-line no-extra-parens
    } while (all[0]);

    return v > 7 ? v : undefined;
}());
